import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
// 持久化
import persistedstate from 'vuex-persistedstate';

import main from './modules/main.js';


export default new Vuex.Store({
  //在严格模式下，无论何时发生了状态变更且不是由 mutation 函数引起的，将会抛出错误
  strict: process.env.NODE_ENV !== 'production',
  modules: {
    main
  },
  plugins: [
    persistedstate({
      storage: window.localStorage
    })
  ]
});



// WEBPACK FOOTER //
// ./src/vuex/index.js